// Lib
import React from 'react';

// Components
import Icon from '../../../components/icons/Icon';

/**
 * The trash icon for the task item delete button, resolved to the current app
 * size and theme like the legacy TaskDeleteButton's icon.
 */
const TaskListDeleteIcon: React.FC = () => <Icon name="task-trash" />;

export default TaskListDeleteIcon;
